import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './styles/index.css'
import './styles/tokens-despacho.css'
import { aplicarTenant } from './tenant/aplicarTenant.js'
import { loadRuntimeConfig } from './config/runtimeConfig.js'

// GEN-PX-001: restyle por tenant (src/tenant/tenant.config.js) sobre los tokens --dk-*.
aplicarTenant()

const raiz = ReactDOM.createRoot(document.getElementById('root'))

// GEN-276: la configuración de la cuenta (config.json) se carga ANTES de montar
// la app, y con ella la autenticación. Si no se puede cargar en producción no
// se arranca con valores adivinados: se dice qué falla.
loadRuntimeConfig().then(
  () => raiz.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ),
  (e) => {
    console.error('[portico] configuración no disponible', e)
    raiz.render(
      <div role="alert" style={{ padding: '2rem', fontFamily: 'sans-serif' }}>
        <h1>No se pudo iniciar el Pórtico</h1>
        <p>Falta su configuración. Avisa al equipo técnico.</p>
      </div>
    )
  }
)
